import React from "react"
import classNames from "classnames"
import { connect } from "react-redux"

import { contentWidth } from "../../common/constants"

import { onSubmit } from "../handlers"
import TimeSelector from "../../common/components/TimeSelector"
import SubmitButton from "./SubmitButton"
import * as actions from "../actions"

const timeUnits = ["minutes", "hours", "days", "weeks", "months", "years"]

const invalidDuration = ({ amount, unit }) => {
  return amount === null || isNaN(amount) || amount === "" || !unit
}

const Duration = ({ item, durationInput, unitSelect, dispatch }) => (
  <div className="row" style={{ marginBottom: 40 }}>
    <ul className={classNames("response-ul", contentWidth)}>
      <div>
        <TimeSelector
          selOptions={timeUnits}
          onInput={durationInput}
          onSelect={unitSelect}
          defaultVal={item.duration}
        />
      </div>
      <SubmitButton
        onSubmit={onSubmit(item, dispatch)}
        disabled={invalidDuration(item.duration)}
      />
    </ul>
  </div>
)

const mapDispatchToProps = (dispatch, ownProps) => ({
  durationInput: e =>
    dispatch(
      actions.durationNumericalResponse(parseInt(e.target.value), ownProps.item)
    ),
  unitSelect: e => {
    let unit = e.target.value
    if (!timeUnits.contains(unit)) return
    dispatch(actions.setDurationUnit(unit, ownProps.item.index))
  },
  dispatch,
})

const DurationContainer = connect(null, mapDispatchToProps)(Duration)

export { DurationContainer as default, Duration }



// WEBPACK FOOTER //
// ./assets/interview/components/DurationResponse.js